import api from './api';

// Staff-side (owner/admin/agent) view of applications within their organisation. The applicant's
// own side of this — filling in details, consenting, submitting — is applicantService.js instead;
// staff never create or submit an application on someone's behalf, only invite and review.
const applicationService = {
  list: async (organisationId, filters = {}) =>
    (await api.get(`/organisations/${organisationId}/applications`, { params: filters })).data,

  get: async (id) => (await api.get(`/applications/${id}`)).data,

  // General staff edits (currently just internal notes — see ApplicationController@update).
  update: async (id, data) => (await api.put(`/applications/${id}`, data)).data,

  timeline: async (id) => (await api.get(`/applications/${id}/timeline`)).data
};

export default applicationService;
